import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const CircleXMark: React.FC<Props> = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="circle close icon">
      {/* <title>circle close icon</title> */}
      <path
        d="M10 2C5.58125 2 2 5.58125 2 10C2 14.4187 5.58125 18 10 18C14.4187 18 18 14.4187 18 10C18 5.58125 14.4187 2 10 2ZM12.5031 11.4688C12.7961 11.7617 12.7961 12.2362 12.5031 12.5294C12.21 12.8225 11.7356 12.8223 11.4425 12.5294L10 11.0594L8.53031 12.5291C8.23716 12.8222 7.76281 12.822 7.46969 12.5291C7.17672 12.2361 7.17672 11.7616 7.46969 11.4684L8.93937 9.99875L7.46875 8.50313C7.17578 8.21016 7.17578 7.73563 7.46875 7.4425C7.76172 7.14937 8.23625 7.14953 8.52938 7.4425L10 8.94063L11.4697 7.47094C11.7627 7.17797 12.2372 7.17797 12.5303 7.47094C12.8234 7.76391 12.8233 8.23844 12.5303 8.53156L11.0606 10.0013L12.5031 11.4688Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default CircleXMark;
